import React from "react";
import { Link } from "react-router-dom";

const TableInbox = ({ item }) => {
  return (
    <tr key={item.id}>
      <td>
        {
          item.payload.headers[
            item.payload.headers.findIndex((from) => from.name === "From")
          ].value
        }
      </td>
      <td>
        <Link to={item.id}>
          {
            item.payload.headers[
              item.payload.headers.findIndex((subj) => subj.name === "Subject")
            ].value
          }
        </Link>
      </td>
      <td>
        {
          item.payload.headers[
            item.payload.headers.findIndex((date) => date.name === "Date")
          ].value
        }
      </td>
    </tr>
  );
};

export default TableInbox;
